import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useLocation, useNavigate } from "react-router-dom";
import apiServiceHandler from "../../service/apiService";
import toastr from "toastr";
import Next90Modal from "./Next90Modal";

const Next90 = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [moreModal, setMoreModal] = useState(false);
  const [moreNext90, setMoreNext90] = useState(false);
  const [next90, setNext90] = useState("");
  const [savedNext90s, setSavedNext90s] = useState([]);
  const [index, setIndex] = useState(0);

  const openModal = () => {
    setMoreModal(true);
  };

  const closeModal = () => {
    setMoreModal(false);
  };

  const isEditable = pathname.split("/").includes("edit");

  const textAreaRef = useRef(null);

  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
  }, [index]);

  const saveNext90 = async (e) => {
    e.preventDefault();

    if (!next90) {
      toastr.error("Please enter a statement before saving.");
      return;
    }

    const updatedStatements = [...savedNext90s];
    updatedStatements[index] = next90;

    const payload = {
      statement: updatedStatements,
      progress: 100,
    };

    try {
      const prevMessagePage =
        localStorage.getItem("prevMessagePage") === "true";
      if (prevMessagePage) {
        navigate("/message-page");
      } else {
        navigate("/plan-for-success");
      }
      const res = await apiServiceHandler("POST", "api/next90", payload);
      setSavedNext90s([]);
      setNext90("");
    } catch (error) {
      console.log("Failed to save credo" + error);
    }
  };

  const handleNoClick = () => {
    const updatedStatements = [...savedNext90s];
    updatedStatements[index] = next90;
    const newIndex = index + 1;
    setSavedNext90s(updatedStatements);
    setNext90(updatedStatements[newIndex] || "");
    setIndex(newIndex);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiServiceHandler("GET", "api/next90", {});
        if (res.status) {
          const statements = res.data.statement || [];
          setSavedNext90s(statements);
          setNext90(statements[0] || "")
        }
      } catch (error) {
        console.error("Failed to fetch statements: " + error);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <main className="auth">
        <div className="auth-layout">
          <div className="auth-view">
            <div className="driver-auth-view__container">
              <div className="driver-view">
                <div className="credo-heading">NEXT 90</div>
                <form className="driver-form">
                  {!moreNext90 && (
                    <div className="driver-view__field">
                      <ReactPlayer
                        url="https://stgmp4folder.s3.us-west-1.amazonaws.com/STG90+Compressed/stg90-13-setting-90-day-targets.mp4"
                        config={{
                          vimeo: {
                            playerOptions: {
                              title: true,
                              byline: false,
                              portrait: false,
                            },
                          },
                        }}
                        controls={true}
                        width="100%"
                        height="100%"
                      />
                    </div>
                  )}

                  <textarea
                    type="text"
                    className="credo-input"
                    ref={textAreaRef}
                    style={
                      moreNext90 ? { height: "380px", width: "500px" } : {}
                    }
                    value={next90}
                    onChange={(e) => setNext90(e.target.value)}
                  />

                  <div
                    style={{
                      display: "flex",
                      gap: "1rem",
                      alignItems: "center",
                    }}
                  >
                    <button
                      type="button"
                      className="driver-btn"
                      onClick={openModal}
                    >
                      <span className="driver-button__label">
                        {isEditable ? "UPDATE" : "SAVE"}
                      </span>
                    </button>
                    <div
                      style={{
                        marginTop: "2rem",
                        color: "#fff",
                        cursor: "pointer",
                      }}
                      onClick={() => navigate("/plan-for-success")}
                    >
                      skip
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Next90Modal
        isOpen={moreModal}
        onClose={closeModal}
        setMoreNext90={setMoreNext90}
        saveNext90={saveNext90}
        handleNoClick={handleNoClick}
      />
    </>
  );
};

export default Next90;
